var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9885 36H16.0115C13.8037 36 12 34.1963 12 31.9885V16.0115C12 13.8037 13.8037 12 16.0115 12H31.9885C34.1963 12 36 13.8037 36 16.0115V31.9885C36 34.2062 34.2062 36 31.9885 36Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0049 30.1651C22.3589 30.1651 20.8115 29.5245 19.6484 28.3614C18.4854 27.1984 17.8447 25.6509 17.8447 24.005C17.8447 22.359 18.4854 20.8115 19.6484 19.6485C20.8115 18.4854 22.3589 17.8448 24.0049 17.8448C25.6509 17.8448 27.1983 18.4854 28.3614 19.6485C29.5244 20.8115 30.1651 22.359 30.1651 24.005C30.1651 25.6509 29.5244 27.1984 28.3614 28.3614C27.1885 29.5245 25.6509 30.1651 24.0049 30.1651ZM24.0049 19.1557C21.3338 19.1557 19.1556 21.324 19.1556 24.005C19.1556 26.676 21.324 28.8542 24.0049 28.8542C26.6759 28.8542 28.8542 26.6859 28.8542 24.005C28.8443 21.3339 26.6759 19.1557 24.0049 19.1557Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3659 17.6423C32.0191 17.6423 32.5487 17.1127 32.5487 16.4595C32.5487 15.8063 32.0191 15.2767 31.3659 15.2767C30.7127 15.2767 30.1831 15.8063 30.1831 16.4595C30.1831 17.1127 30.7127 17.6423 31.3659 17.6423Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.d17cbad9a73509376194c16f6898c516.svg";
export { ForwardRef as ReactComponent };